import { createFetcher } from '../../Common';

import { COLORS_ENDPOINT, getBaseUrl, USEREVENT_COLOR_ENDPOINT } from '../../constants';

class Settings {
  static instance = null;

  static getInstance() {
    if (!this.instance) {
      this.instance = new Settings(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.fetcher = fetcher;
    this.colorsEndpoint = COLORS_ENDPOINT;
    this.userEventColorEndpoint = USEREVENT_COLOR_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getHrThemeColors() {
    const endpoint = `${this.base_url}${this.colorsEndpoint}`;
    const response = await this.fetcher.getData(endpoint);
    return response?.data;
  }

  async putHrColorSettings(args) {
    const { userId, ...data } = args;
    const endpoint = `${this.base_url}${this.userEventColorEndpoint}/${userId}`;
    const response = await this.fetcher.putData(endpoint, data);
    return response?.data;
  }

  async postHrColorSettings(reqBody) {
    const endpoint = `${this.base_url}${this.userEventColorEndpoint}`;
    const response = await this.fetcher.postData(endpoint, reqBody);
    return response?.data;
  }

  async getHrColorCodeMapping() {
    const endpoint = `${this.base_url}${this.userEventColorEndpoint}`;
    const response = await this.fetcher.getData(endpoint);
    return response?.data;
  }

  async deleteHrColorCodeMapping(userId) {
    const endpoint = `${this.base_url}${this.userEventColorEndpoint}/${userId}`;
    const response = await this.fetcher.deleteData(endpoint);
    return response?.data;
  }
}

export const createSettings = () => Settings.getInstance();
